import StudentDto from "../../dto/StudentDto";

export default class StudentUpdateRequest {
  students = [];
  constructor(datas) {
    datas.forEach(data => {
      const students = new StudentDto(data);
      this.students.push(students);
    });
  }
}
